export function getJSON(url, obj) {
    return new Promise(function (resolve, reject) {
        loadFromServer(url, obj, resolve, reject);
    })
}

export function sendToServer(url, method, data){
    return new Promise((resolve, reject) => {
        let myInit = {
            method: method,
            mode: 'cors',
            cache: 'default',
            headers: getHeaders(),
            body: JSON.stringify(data)
        };
        fetch(url, myInit)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (result) {
                reject(result);
            });
    });
}

function getHeaders(){
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Origin', '*');
    myHeaders.append('X-Requested-With', '*');
    myHeaders.append('ApokClient', 'p498h20ernc0289rnf298234ufn2903874nc8n45245v2');
    myHeaders.append('ApokToken', '13ij4hbr0f18374nc987342bc875bhq37h45hq087cbh0q87n');
    return myHeaders;
}

function loadFromServer(url, obj, callback, callbackError){
    //console.log("Cargando: "+url);
    let myInit = {
        method: 'GET',
        mode: 'cors',
        cache: 'default',
        headers: getHeaders()
    };
    fetch(url, myInit)
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }
            return response.json();
        })
        .then(function (result) {
            callback(result);
        })
        .catch(function (error) {
            if (callbackError) {
                callbackError(error);
            }
        });
}


// WEBPACK FOOTER //
// ./src/constants/network.js